export const AUTH_ON_INITIALIZE_REQUESTED = 'AUTH_ON_INITIALIZE_REQUESTED';
export const AUTH_ON_INITIALIZE_SUCCEEDED = 'AUTH_ON_INITIALIZE_SUCCEEDED';
export const AUTH_ON_INITIALIZE_FAILED = 'AUTH_ON_INITIALIZE_FAILED';

export const AUTH_ON_LOGIN_REQUESTED = 'AUTH_ON_LOGIN_REQUESTED';
export const AUTH_ON_LOGIN_SUCCEEDED = 'AUTH_ON_LOGIN_SUCCEEDED';
export const AUTH_ON_LOGIN_FAILED = 'AUTH_ON_LOGIN_FAILED';

export const AUTH_ON_LOGIN_PUBLIC_REQUESTED = 'AUTH_ON_LOGIN_PUBLIC_REQUESTED';
export const AUTH_ON_LOGIN_PUBLIC_SUCCEEDED = 'AUTH_ON_LOGIN_PUBLIC_SUCCEEDED';
export const AUTH_ON_LOGIN_PUBLIC_FAILED = 'AUTH_ON_LOGIN_PUBLIC_FAILED';

export const AUTH_ON_LOGOUT_REQUESTED = 'AUTH_ON_LOGOUT_REQUESTED';
export const AUTH_ON_LOGOUT_SUCCEEDED = 'AUTH_ON_LOGOUT_SUCCEEDED';
export const AUTH_ON_LOGOUT_FAILED = 'AUTH_ON_LOGOUT_FAILED';

export const AUTH_ON_LOGOUT_PUBLIC_REQUESTED = 'AUTH_ON_LOGOUT_PUBLIC_REQUESTED';
export const AUTH_ON_LOGOUT_PUBLIC_SUCCEEDED = 'AUTH_ON_LOGOUT_PUBLIC_SUCCEEDED';
export const AUTH_ON_LOGOUT_PUBLIC_FAILED = 'AUTH_ON_LOGOUT_PUBLIC_FAILED';

export const AUTH_ON_REGISTER_PUBLIC_REQUESTED = 'AUTH_ON_REGISTER_PUBLIC_REQUESTED';
export const AUTH_ON_REGISTER_PUBLIC_SUCCEEDED = 'AUTH_ON_REGISTER_PUBLIC_SUCCEEDED';
export const AUTH_ON_REGISTER_PUBLIC_FAILED = 'AUTH_ON_REGISTER_PUBLIC_FAILED';
